<Sprite sheet={sheet} />

<script>
import { computed } from "canvasengine";
import { RpgClientEngine } from "../../RpgClientEngine";
import { inject } from "../../core/inject";
import { resolveDynamicValue } from "./parse-value";

const { object, value } = defineProps();
const sprite = object();
const client = inject(RpgClientEngine);

const sheet = computed(() => {
  const id = resolveDynamicValue(value?.(), sprite);
  if (!id) return null;
  return {
    definition: client.getSpriteSheet(id),
    playing: 'default'
  };
});
</script>
